import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import ReactPlayer from "react-player";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../Common/Permission";
import Button from "sushiweb/Button";

const CampaignInfo = (props) => {
  const { activeCampaignDetails, activeCampaignId, deactivateStory } = props;
  const allActions = MenuActionsMappings[MenuNames.DRIVER_STORIES];
  const history = useHistory();

  const hasOwnPropertyCheck = (element, key1, key2 = "") => {
    if (key2 == "") {
      return element.hasOwnProperty(key1);
    }
    return element.hasOwnProperty(key1) && element[key1].hasOwnProperty(key2);
  };

  const onDeactivate = () => {
    deactivateStory({
      story_id: activeCampaignId,
      update_type: "DEACTIVATE_STORY",
    }).then(() => {
      setTimeout(() => {
        history.push(`/stories`);
        window.location.reload();
      }, 1000);
    });
  };

  const generateDetailField = (objectKey) => {
    return (
      hasOwnPropertyCheck(activeCampaignDetails, "story_details") &&
      activeCampaignDetails?.story_details.map((detail) => {
        return <p>{detail?.[objectKey]}</p>;
      })
    );
  };

  return (
    <CampaignInfoContainer align="flex-start">
      <Permission requiredPerms={[allActions.STORIES_VIEW]}>
        <CampaignInfoContainer.LeftSection>
          <FlexContainer align="flex-start" className="mb-20">
            <LeftSection>
              {generateDetailField("key")}
            </LeftSection>
            <RightSection>
              {generateDetailField("value")}
            </RightSection>
          </FlexContainer>
          <Permission requiredPerms={[allActions.STORIES_CREATE]}>
            <Button
              data-testid="submitButton"
              className="sushi-btn ml-auto"
              onClick={onDeactivate}
              disabled={
                !(
                  activeCampaignDetails.status === "LIVE" ||
                  activeCampaignDetails.status === "APPROVED"
                )
              }
            >
              Deactivate
            </Button>
          </Permission>
        </CampaignInfoContainer.LeftSection>
        <CampaignInfoContainer.RightSection>
          {hasOwnPropertyCheck(activeCampaignDetails, "media", "type", "url") &&
          activeCampaignDetails?.media?.type === "IMAGE" ? (
            <ImageContainer>
              <p>Attached Media:</p>
              <img src={activeCampaignDetails?.media?.url} alt="image"></img>
            </ImageContainer>
          ) : (
            <VideoContainer>
              <p>Attached Media:</p>
              <ReactPlayer
                controls={true}
                className="react-player"
                width="70%"
                height="250px"
                url={activeCampaignDetails?.media?.url}
              />
            </VideoContainer>
          )}
        </CampaignInfoContainer.RightSection>
      </Permission>
    </CampaignInfoContainer>
  );
};

const ImageContainer = styled.div`
  img {
    border-radius: 16px;
    width: 70%;
    height: 250px;
    margin-bottom: 50px;
  }
`;

const VideoContainer = styled.div`
  video {
    border-radius: 16px;
  }
`;

const CampaignInfoContainer = styled(FlexContainer)`
  padding: 1.5rem;
  border-bottom: 1px solid ${variables.borderColor};
  p {
    color: #9197a6;
    margin: 8px;
  }
  justify-content: space-around;
`;

const CTASection = styled.div`
  justify-content: flex-start;
  flex: 0 1 50%;
`;

CampaignInfoContainer.LeftSection = styled.div`
  justify-content: flex-start;
  flex: 0 1 60%;
  background-color: #ffffff;
  padding: 2rem;
`;
CampaignInfoContainer.RightSection = styled.div`
  flex: 0 1 38%;
`;

const LeftSection = styled.div`
  justify-content: flex-start;
`;
const RightSection = styled.div`
  flex: 0 1 75%;
`;

const NotificationTitle = styled.div`
  background-color: #fbfbfb;
  height: 2.5em;
  width: 20em;
  border-radius: 3px;
  border: 1px solid ${variables.borderColor2};
  margin-left: 5px;
  margin-bottom: 20px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;
const NotificationContent = styled.div`
  background-color: #fbfbfb;
  height: 10em;
  width: 40em;
  border-radius: 3px;
  border: 1px solid ${variables.borderColor2};
  margin-left: 5px;
  margin-bottom: 20px;
  overflow-y: auto;
`;

export default CampaignInfo;
